const filter_by_function = ( array, func ) =>
{
  return array.filter( func );
};

const remove_children = ( parent ) =>
{
  while ( parent.firstChild )
  {
    parent.removeChild( parent.firstChild );
  }
  return parent;
}

const append_children = ( parent, node_list ) =>
{
  const children = Array.from( node_list );

  while ( children.length )
  {
    parent.appendChild( children.shift() );
  }
  return parent;
}

const sanatise_string = ( string ) =>
{
  return string.trim().toLowerCase();
}


const validate_string = ( () =>
{
  const valid_chars = [ 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z' ];

  return ( string ) =>
  {
    return string === '' || string === ' '
      ? false
      : valid_chars.indexOf( string.toLowerCase().substring( 0, 1 ) ) === -1
      ? false
      : true;
  }
} )();

const get_node_index = ( nodelist, node ) =>
{
  return nodelist.indexOf( node );
}


const create_countup_instances = ( list, endVal ) =>
{
  const array = [];

  for ( const item of list )
  {
    array.push( new CountUp( item.id, endVal.get(),
    {
      startVal: 0,
    } ) );
  };

  return array;
};


const ecommerce_counter = ( ( selector, delay, random, cb ) =>
{
  const node_list = Array.from( cached_elements.get_nodelist( selector ) );

  const countup_instances = [ ...create_countup_instances( node_list, random ) ];

  return ( func, init = false ) =>
  {
    const new_numbers = [];

    for ( const instance of countup_instances )
    {
      const new_number = random.get();
      init ? instance.start() : instance.update( new_number );
      new_numbers.push( new_number );
    };

    if ( cb )
    {
      cb( new_numbers );
    }

    setTimeout( () =>
    {
      func( func );
    }, delay );
  }
} );